import { format } from "date-fns";
import { formatDate } from "../../utils";
import { value } from "../../helpers";

export const PERIODO_PRESETS = [
  { label: "7 dias", dias: 7 },
  { label: "15 dias", dias: 15 },
  { label: "30 dias", dias: 30 },
  { label: "Este mês", mes: true },
];

export function periodoInicial() {
  const hoje = new Date();
  const de = new Date();
  de.setDate(de.getDate() - 30);
  return { de: formatDate.toSend(de), ate: formatDate.toSend(hoje) };
}

export const filtrosIniciais = {
  ...periodoInicial(),
  empresas: [],
  prestadores: [],
  grupoServico: null,
  tipoServico: null,
};

export function buildFiltrosBody(filtros) {
  return {
    filtros: {
      porIntervalo: [
        { de: filtros.de, ate: filtros.ate, coluna: "dataLancamento" },
      ],
      empresasIds: filtros.empresas?.length
        ? filtros.empresas.map((e) => e.id)
        : undefined,
      prestadores: filtros.prestadores,
      grupoServicoId: filtros.grupoServico?.id || undefined,
      servicoId: filtros.tipoServico?.id || undefined,
    },
  };
}

export function intervaloPreset(preset) {
  const ate = new Date();
  let de = new Date();
  if (preset.mes) {
    de = new Date(ate.getFullYear(), ate.getMonth(), 1);
  } else {
    de.setDate(de.getDate() - preset.dias + 1);
  }
  return { de: formatDate.toSend(de), ate: formatDate.toSend(ate) };
}

export function presetSelecionado(filtros) {
  const ate = new Date(filtros.ate);
  const de = new Date(filtros.de);
  const diffTime = Math.abs(ate - de);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  if (diffDays === 7) return PERIODO_PRESETS[0];
  if (diffDays === 15) return PERIODO_PRESETS[1];
  if (diffDays === 30) return PERIODO_PRESETS[2];
}

export function formatarDataChip(dataStr) {
  if (!dataStr) return "";
  return format(value.date(dataStr), "dd/MM/yyyy");
}
